import React from "react";
import "./css/Accreditation.css";

interface AccreditationProps {
    version: string;
}

export const Accreditation: React.FC<AccreditationProps> = ({ version }) => {
    return (
        <div className="accreditation-container">
            <section className="accreditation-section">
                <h2>Authorship</h2>
                <p>Skitterbook is authored and maintained by FAR Authoring.</p>
            </section>

            <section className="accreditation-section">
                <h2>Development Period</h2>
                <p>September 2025 – February 2026</p>
            </section>

            <section className="accreditation-section">
                <h2>Version</h2>
                <p>{version}</p>
            </section>
        </div>
    );
};

export default Accreditation;
